/** Wiadomości systemowe — blokujący komunikat dyrektora do wybranych pracowników. */

export interface SystemMessage {
  id: string;
  title: string;
  body: string;
  display_seconds: number;
  sender_name: string | null;
  recipient_count: number;
  read_count: number;
  created_at: string;
}

/** Co dostaje odbiorca w blokującym oknie — bez listy odbiorców i statystyk. */
export interface PendingSystemMessage {
  id: string;
  title: string;
  body: string;
  display_seconds: number;
  sender_name: string | null;
  created_at: string;
}

/** Pracownik, którego nadawca może wskazać (zakres = oddziały, które widzi). */
export interface RecipientOption {
  id: string;
  name: string;
  role: string;
  role_label: string;
  job_title: string;
  branch_id: string | null;
  branch_name: string | null;
}

export interface SystemMessageReceipt {
  id: string;
  name: string;
  role: string;
  role_label: string;
  branch_name: string | null;
  is_read: boolean;
  read_at: string | null;
}

export interface SystemMessageReceipts {
  read: SystemMessageReceipt[];
  unread: SystemMessageReceipt[];
  total: number;
  read_count: number;
  unread_count: number;
}

export interface SystemMessageFormData {
  title: string;
  body: string;
  recipient_ids: string[];
  /** Ustawiane, gdy zaznaczono wszystkich — odbiorców rozstrzyga wtedy backend. */
  send_to_all: boolean;
}

/** Kto może wysyłać. Lustro `apps/system_messages/services.can_send` — backend rozstrzyga. */
export function canSendSystemMessages(
  user: { role: string; is_ceo: boolean; is_developer?: boolean } | null,
): boolean {
  if (!user) return false;
  if (user.role === "contractor") return false;
  return user.role === "director" || user.is_ceo || !!user.is_developer;
}
